import fetch from "./fetch";
/**
 * 用户相关信息
 */
const operations = {
  // 修改密码
  editPassword(data) {
    return fetch({
      isLoading: true,
      url: "/v1/sys/changePassWord",
      method: "POST",
      data,
    });
  },
};

export default operations;
